import LinkToDocusaurus from '../LinkToDocusaurus'
import { testConfig } from '../../docs-routes'

const LinkToTestConfigDoc = () =>
  <LinkToDocusaurus path={testConfig}>
    Learn more about Test Config
  </LinkToDocusaurus>

export default LinkToTestConfigDoc
